import React, { useEffect } from "react";
import { fetchMasterAppointmentTypeActuationList } from "../../../../../../redux/actions/masterAppointment/appointmentTypeActuation/appointmentTypeActuation";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import { CustomDetailsList } from "../../../../../common/customDetailsList/customDetailsList";
import { Skeleton } from "../../../../../common/skeleton/skeleton";
import { MasterAppointmentTypeFormController } from "../controller/controller";
import { MasterAppointmentTypeActuationColumns } from "./column/column";
import { SkeletonSizes } from "../../../../../../common/enum/sizes";

interface IMasterAppointmentTypeListContainerProps {}

export const MasterAppointmentTypeActuationListContainer: React.FC<IMasterAppointmentTypeListContainerProps> = () => {
    const { list, loading } = useAppSelector((state) => state.masterAppointmentTypeActuationList);
    const dispatch = useAppDispatch();
    const renderColumns = () => {
        return MasterAppointmentTypeActuationColumns();
    };
    useEffect(() => {
        list === undefined && !loading && dispatch(fetchMasterAppointmentTypeActuationList());
    }, [list]);

    return (
        <div style={{ height: "100%" }}>
            {loading ? (
                <Skeleton rows={SkeletonSizes.DEFAULT} />
            ) : (
                <CustomDetailsList
                    data={list ?? []}
                    renderColumns={renderColumns}
                    height={"calc(100vh - 10rem)"}
                />
            )}

            <MasterAppointmentTypeFormController />
        </div>
    );
};
